import { ArrowLeftRight, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { Button } from '@/components/ui/Button'
import { PageHeader } from '@/components/ui/PageHeader'
import { Can } from '@/features/auth/guards'
import { useAuth } from '@/features/auth/useAuth'
import { CatalogBrowser } from '@/features/library/components/CatalogBrowser'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'
import { LibraryStatsRow } from './LibraryStatsRow'

export function CatalogPage() {
  const { t } = useTranslation('library')
  useDocumentTitle('Library catalogue')
  const { can } = useAuth()
  return (
    <>
      <PageHeader
        title={t('Catalogue')}
        description={t('Every title in the library, with live copy availability.')}
        breadcrumbs={[{ label: t('Resources') }, { label: t('Library') }, { label: t('Catalogue') }]}
        homeHref="/admin"
        actions={
          <Can permission="library.manage">
            <Button asChild variant="secondary" leftIcon={<ArrowLeftRight />}>
              <Link to="/admin/library/circulation">{t('Circulation desk')}</Link>
            </Button>
            <Button asChild leftIcon={<Plus />}>
              <Link to="/admin/library/books/new">{t('Add book')}</Link>
            </Button>
          </Can>
        }
      />
      <LibraryStatsRow />
      <CatalogBrowser
        detailHref={(b) => `/admin/library/books/${b.id}`}
        showStatusFilter={can('library.manage')}
      />
    </>
  )
}
